export function getIconByFileType(fileType,fileName?:string,sameFile?:boolean): string {
    const type = fileType.toLowerCase();
  
    // PDF
    if (type === 'application/pdf') {
      return 'assets/icons/pdf.svg';
    }
  
    // Word Docs
    if (
      type === 'application/msword' || // .doc
      type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || // .docx
      type === 'application/vnd.ms-word.document.macroEnabled.12'
    ) {
      return 'assets/icons/doc.svg';
    }
  
    // Images
    if (type.startsWith('image/')) {
      return sameFile&&fileName?fileName:'assets/icons/image.svg';
    }
  
    // Excel
    if (
      type === 'application/vnd.ms-excel' ||
      type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ) {
      return 'assets/icons/excel.svg';
    }
  
    // PowerPoint
    if (
      type === 'application/vnd.ms-powerpoint' ||
      type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
    ) {
      return 'assets/icons/ppt.svg';
    }
  
    // Text files
    if (type === 'text/plain') {
      return 'assets/icons/txt.svg';
    }
  
    // Fallback
    return 'assets/icons/upload-file.png';
  }